import type { SprintDefinition } from './types';

/**
 * Pick the sprint to default to: an in-progress sprint if one exists,
 * otherwise the next upcoming, otherwise the most recent past sprint.
 * Returns '' when no sprints are defined.
 */
export function getDefaultSprintId(sprints: SprintDefinition[], now: Date = new Date()): string {
  if (sprints.length === 0) return '';
  const ms = now.getTime();
  const ongoing = sprints.find(
    (s) => ms >= new Date(s.startsAt).getTime() && ms <= new Date(s.endsAt).getTime(),
  );
  if (ongoing) return ongoing.id;
  const upcoming = [...sprints]
    .filter((s) => new Date(s.startsAt).getTime() > ms)
    .sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime())[0];
  if (upcoming) return upcoming.id;
  return sprints[sprints.length - 1].id;
}
